import { SVGProps } from 'react'

export const CameraRotateMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#00A4FF" />
    <path
      d="M12.5 21.5C12.5 21.5 12.591 22.1369 15.227 24.773C17.8631 27.409 22.1369 27.409 24.773 24.773C25.7069 23.839 26.31 22.6995 26.5821 21.5M12.5 21.5V26M12.5 21.5H17M27.5 18.5C27.5 18.5 27.409 17.8631 24.773 15.227C22.1369 12.591 17.8631 12.591 15.227 15.227C14.2931 16.161 13.69 17.3005 13.4179 18.5M27.5 18.5V14M27.5 18.5H23"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
